import { SVGAssets } from '@business/assets/vectors';
import { ContextMenuItem } from '@business/workflows/ComponentUI';
import { useState, useCallback } from 'react';
import { useTrashRestoreDelete } from './TrashRestoreDelete';

const contextMenuIconClassName = 'w-4 h-4 text-[#505050]';
const contextMenuIconClassNameRed = 'w-4 h-4 text-red-600';

export const usePeopleTrashContextMenu = () => {
  const [selectedPerson, setSelectedPerson] = useState<any>(null);
  const [isPeopleDeleteConfirm, setIsPeopleDeleteConfirm] =
    useState<boolean>(false);
  const [restorePersonId, setRestorePersonId] = useState<string>('');
  const [isPersonRestoreConfirm, setIsPersonRestoreConfirm] =
    useState<boolean>(false);

  const { deleteItem, restoreItem } = useTrashRestoreDelete();

  const handleDeletePerson = (
    personId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    deleteItem({
      module: 'people',
      moduleId: personId,
      onSuccess: () => {
        setSelectedPerson(null);
        setIsPeopleDeleteConfirm(false);
        onSuccess?.();
      },
      onError
    });
  };

  const handleRestorePerson = (
    personId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    restoreItem({
      module: 'people',
      moduleId: personId,
      onSuccess: () => {
        setRestorePersonId('');
        setIsPersonRestoreConfirm(false);
        onSuccess?.();
      },
      onError: err => {
        setIsPersonRestoreConfirm(false);
        onError?.(err);
      }
    });
  };

  const peopleContextMenuItems = useCallback(
    (person: any) => [
      {
        id: '1',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.ProfileEditIcon className={contextMenuIconClassName} />
            }
            label="Restore"
          />
        ),
        onClick: () => {
          setRestorePersonId(person?.id);
          setIsPersonRestoreConfirm(true);
        }
      },
      {
        id: '2',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.TrashIcon className={contextMenuIconClassNameRed} />
            }
            label="Delete"
            labelClassName="text-red-600"
          />
        ),
        onClick: () => {
          setSelectedPerson(person?.id);
          setIsPeopleDeleteConfirm(true);
        }
      }
    ],
    []
  );

  return {
    peopleContextMenuItems,
    selectedPerson,
    setSelectedPerson,
    isPeopleDeleteConfirm,
    setIsPeopleDeleteConfirm,
    restorePersonId,
    setRestorePersonId,
    isPersonRestoreConfirm,
    setIsPersonRestoreConfirm,
    handleDeletePerson,
    handleRestorePerson
  };
};
